// extracted by mini-css-extract-plugin
export default {"swapUsersDescription":"styles_swapUsersDescription__rv0QN","bone-skeleton":"styles_bone-skeleton__AvriJ"};